import { forwardRef } from 'react';
import cn from 'classnames';
import { jsxs } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["children", "onClick", "showExternalLinkWarning", "externalLinkWarningText", "className", "styleType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Hyperlink = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      _ref$showExternalLink = _ref.showExternalLinkWarning,
      showExternalLinkWarning = _ref$showExternalLink === void 0 ? false : _ref$showExternalLink,
      _ref$externalLinkWarn = _ref.externalLinkWarningText,
      externalLinkWarningText = _ref$externalLinkWarn === void 0 ? "(opens new window)" : _ref$externalLinkWarn,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$styleType = _ref.styleType,
      styleType = _ref$styleType === void 0 ? "underline" : _ref$styleType,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs("a", _objectSpread(_objectSpread({
    "data-auto": "eb-hyperlink",
    className: cn("eb-hyperlink", "eb-hyperlink--".concat(styleType), className),
    rel: "noopener noreferrer",
    onClick: function onClick(event) {
      return _onClick && _onClick(event);
    },
    ref: ref
  }, props), {}, {
    children: [children, showExternalLinkWarning && " ".concat(externalLinkWarningText)]
  }));
});
Hyperlink.displayName = "Hyperlink";

export { Hyperlink as default };
//# sourceMappingURL=hyperlink-esm.js.map
